export const INFO_BLOCK_TYPE = {
  CONTACT_US: 'CONTACT_US',
  DELIVERY: 'DELIVERY',
  TERMS_AND_CONDITIONS: 'TERMS_AND_CONDITIONS',
  ABOUT_US: 'ABOUT_US',
  LOGIN: 'LOGIN',
};
